import type { AnchorHTMLAttributes, DetailedHTMLProps, ReactElement } from 'react';
import React from 'react';

type Props = {
  href: string;
  children: string | ReactElement | ReactElement[];
} & DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>; // allow other anchor tag props

export default function ExternalLink(props: Props): ReactElement {
  const { children, ...anchorProps } = props;
  return (
    <a {...anchorProps} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
